import { cloneDeep } from "lodash";
import { DATA_TYPE, FIELD_TYPE, RECORD_TYPE } from "../constants/datatypes";
import { getUpdatedData as inboundUpdatedData } from "../components/RightContextMenu/ContextActions/NewRecord";
import { getUpdatedData as outboundUpdatedData } from "../components/RightContextMenu/ContextActions/NewRecordOutbound";
import { t } from "i18next";

const COMMON_TEMPLATE_HEADER_PROPERTIES= ['ACCOUNT_NAME', 'BUILD', 'FILETYPE', 'LAST_MODIFIED_USER', 'NOTES', 'REVISION_ID', 'TEMPLATE', 'VERSION', 'WF_GROUP'];
const SPECIFIC_TEMPLATE_HEADER_PROPERTIES = {
    "CSV" : ['LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV'],
    "DATABASE": ['URLDECODE', 'PREDEFINED_CONNECTION'],
    "DELIMITED": ['DELIMITER', 'LENIENT_RECORD_DELIMITER','LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV'],
    "DELIM_FLD_ID": ['DELIMITER','LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV', 'GROUP_SEPARATOR'],
    "EDI": ['DELIMITER','LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV', 'CREATE_DOCUMENT_REPORT','EDI_RELEASE_UID','FILETYPE_VERSION','GROUP_SEPARATOR','HEADER_RECORD_TYPE','RECORDDELIM','REMOVE_TRAILING_FIELD_DELIMITERS','SUB_TYPE','TRAILER_RECORD_TYPE','TXN_SET_TYPE','REPETITION_DELIMITER'],
    "EXCEL" : ['URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV','USE_LEGACY_NON_STREAMING',"SHEET_NAME"],
    "FIXED_LENGTH" : ['DELIMITER','LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV'],
    "HL7" : ['DELIMITER','LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV','FILETYPE_VERSION','GROUP_SEPARATOR','MESSAGE_TYPE','REPETITION_DELIMITER','SUBCOMPONENT_DELIMITER','TRIGGER_EVENT'],
    "JSON": ["DELIMITER", "LINEDELIMITER","GROUP_RECORD_TYPE","GROUP_MAPNAME","REPETITION_DELIMITER","FILE_PATH","OVERRIDE_ROOT_ELEMENT","VALIDATION_TYPE"],
    "MULIT_DELIMITED": ['DELIMITER','LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'TRIMDATA', 'UNCSV', 'GROUP_SEPARATOR',"ESCAPE_CHARACTER","REPETITION_DELIMITER","SUBCOMPONENT_DELIMITER"],
    "NVP" : ['LINEDELIMITER', 'URLDECODE', 'GROUP_RECORD_TYPE', 'GROUP_MAPNAME', 'UNCSV', 'VAL_BEGIN_DELIMITER', 'VAL_END_DELIMITER'],
    "SERVLET": ["GROUP_RECORD_TYPE", "GROUP_MAPNAME"],
    "XML": ["URLDECODE", "TRIMDATA", "FILE_PATH","OVERRIDE_ROOT_ELEMENT","VALIDATION_TYPE","PRESERVE_NAMESPACES_WHEN_MAPPING","ROOT_ELEMENT","USE_NAMESPACE"]
}

const OUTBOUND_DATATYPE_REMOVE_VALUES = {
    FIXED_LENGTH: ["DELIMITER"],
    GraphQL: ["DELIMITER","LINEDELIMITER","GROUP_RECORD_TYPE","GROUP_MAPNAME","UNCSV","FILE_PATH","OVERRIDE_ROOT_ELEMENT", "XML_BODY_NAME"]
};

export const getRePopulatedData = (datatype,prevDataType,version,tree = [],screen) =>{
    if(screen === "inbound") return reGenerateInboundData(datatype,prevDataType,version,tree, screen);
    else return reGenerateOutboundData(datatype,prevDataType,version,tree, screen);
}

export const getRePopulatedtemplateHeader = (datatype,prevDataType,version,data = {},screen) =>{
    if(screen === "inbound") return reGenerateInboundTemplateHeader(datatype,prevDataType,version,data);
    if (screen === "outbound") return reGenerateOutboundTemplateHeader(datatype,prevDataType,version,data);
}

const reGenerateInboundData = (datatype,prevDataType,version,tree = [], screen) =>{
    const tempData = cloneDeep({
        header:tree?.header?.translatedData || [],
        body:tree?.body?.translatedData || [],
        trailer:tree?.trailer?.translatedData || [],
    })
    Object.keys(tempData).forEach(tab=>{
        tempData[tab] = populateTree(tab,tempData[tab],datatype,prevDataType,version, screen);
    })
    return tempData;
}


const reGenerateOutboundData =(datatype,prevDataType,version,tree = [],screen) =>{
    //TODO: outbound tree conversion need to be implemented
    const tempData = cloneDeep({
        header:tree?.header?.translatedData || [],
        body:tree?.body?.translatedData || [],
        trailer:tree?.trailer?.translatedData || [],
    })
    Object.keys(tempData).forEach(tab=>{
        tempData[tab] = populateTree(tab,tempData[tab],datatype,prevDataType,version, screen);
    })
    return tempData;
}


const populateTree = (tabType,data,datatype,prevDataType,version, screen) =>{
    if(['XML','JSON','DATABASE', 'GraphQL'].includes(datatype) && tabType !== "body") return [];
    if(['XML','JSON'].includes(datatype) && tabType === "body" && data?.[0]?.children?.length > 1 && screen !== "outbound"){
        // Keep only one Root Element
        data[0].children = [data[0].children[0]];
    }
    // When changing datatype to GraphQL, the template should have no header/trailer
    // and the BODY should be a single GraphQL record node with a constant FIELD
    if (datatype === 'GraphQL' && tabType === 'body') {
        data = [{
            DESCRIPTION: 'UNNAMED',
            ICON_DISPLAY: RECORD_TYPE.RECORD.icon,
            EMPTY_ACTION: "EMPTY",
            FIELD: { FIELDTYPE: "CONSTANT"},
            GRAPHQL_RECORD: "TRUE",
            LOOP: "SINGLE",
            title: `${t("LBL_RECORD")}`,
            children: []
        }];
    }
    const updateNewData = (data = [],parent)=>{
        const recordsNodes=[];
        const nonRecordNodes =[];
        data?.forEach((e, i) => {
            const parentNode = cloneDeep(e);
            let states = {isRecord:false,isValid:true,nestChild:true};
            if (e?.ICON_DISPLAY !== "TEMPLATE_BODY_DOTS"){
                if(datatype === 'XML') XMLHandler(e,datatype,prevDataType,parent,i, screen);
                else states = otherDataTypeHandler(e,datatype,prevDataType,version,parent,i, screen);
            } 
            // console.log(states,e,parent);
            if(!states.nestChild) e.children = [];
            if(states.isValid && e?.children?.length) e.children = updateNewData(e?.children,parentNode);
            if(states.isRecord && states.isValid) recordsNodes.push(e);
            else if(!states.isRecord && states.isValid) nonRecordNodes.push(e);
        })
        return [...nonRecordNodes,...recordsNodes];
    }
    const returned  = screen === 'inbound' ? inboundUpdatedData(updateNewData(data),datatype) : outboundUpdatedData(updateNewData(data),datatype, prevDataType, screen === 'workflow', tabType); ;
    return returned;
}


const otherDataTypeHandler = (e,datatype,prevDataType,version,parent, index, screen) =>{
    let states = {isRecord:false,isValid:true,nestChild:true};
    if (datatype === "JSON" && e?.key?.split('-')?.length === 3 &&  screen === "inbound"){
        e["ICON_DISPLAY"] = RECORD_TYPE.RECORD_TOP.icon;
    }
    else if (["JSON", "DATABASE"].includes(datatype) && e?.key?.split('-')?.length === 2 &&  screen === "outbound"){
        // e["ICON_DISPLAY"] = datatype === "JSON" ? RECORD_TYPE.RECORD_TOP.icon : RECORD_TYPE.QUERY.icon;
        // e["ICON_DISPLAY"] = datatype === "JSON" ? RECORD_TYPE.RECORD_TOP.icon : RECORD_TYPE.QUERY.icon;
        e["ICON_DISPLAY"] = datatype === "JSON" ? RECORD_TYPE.RECORD_TOP.icon : (e?.TYPE && e?.TYPE !== "SELECT") ? RECORD_TYPE.RECORD_LOOP.icon : RECORD_TYPE.RECORD.icon;

        states.isRecord = true;
        // console.log(e);
    }
    else if(RECORD_TYPE?.[e?.ICON_DISPLAY] && ((screen === "outbound" && (e?.ICON_DISPLAY !== "QUERY" || e?.key?.split('-')?.length === 2)) || screen === "inbound")){
        if(prevDataType === "XML" && !e?.isRecord && !e?.children?.length  && e.ICON_DISPLAY !== RECORD_TYPE.REPEATING_ELEMENT.icon){
            e['ICON_DISPLAY'] = DATA_TYPE?.[datatype].field.icon;
            e['MAPNAME'] = (e.MAPNAME || e.ELEMENT_NAME || e.TYPE);
            e['title'] = `${t("LBL_FIELD")} ${e?.FIELDTYPE === "CONSTANT" ? `(${t("CONSTANT")})` : ""} ${e.MAPNAME || e.ELEMENT_NAME || e.TYPE || e.DESCRIPTION || ""}`;
            e["DESCRIPTION"] = e?.DESCRIPTION || e?.ATTRIBUTE_NAME || e?.MAPNAME
        }
        else if (datatype === "DATABASE" && screen === "outbound") {
            e['ICON_DISPLAY'] = e?.TYPE !== "SELECT" ? RECORD_TYPE.RECORD_LOOP.icon : RECORD_TYPE.RECORD.icon;
            // For DATABASE, use loop record value if available
            const loopRecordValue = e?.LOOP_SOURCE_NAME || e?.SOURCE_TYPE || e?.TYPE;
            if (loopRecordValue && loopRecordValue !== t("SELECT")) {
                e['title'] = `${t("LBL_RECORD")} ${loopRecordValue}`;
            } else {
                e['title'] = `${t("LBL_RECORD")} ${e?.DESCRIPTION || e?.ELEMENT_NAME || e?.MAPNAME || ""}`;
            }
            states.isRecord=true;
        }else{
            e['ICON_DISPLAY'] = e?.LOOP_SOURCE_NAME ? RECORD_TYPE.RECORD_LOOP.icon : DATA_TYPE?.[datatype].record.icon;
            // Use loop record value for title when converting from XML
            if (prevDataType === "XML" && screen === "outbound") {
                const loopRecordValue = e?.LOOP_SOURCE_NAME || e?.SOURCE_TYPE || e?.TYPE;
                if (loopRecordValue && loopRecordValue !== t("SELECT")) {
                    e['title'] = `${t("LBL_RECORD")} ${loopRecordValue}`;
                } else {
                    e['title'] = `${t("LBL_RECORD")} ${e?.DESCRIPTION || e?.ELEMENT_NAME || e?.MAPNAME || ""}`;
                }
            } else {
                e['title'] = `${(screen === "outbound" ? t("LBL_RECORD") : "")} ` + (screen === "outbound" ? (e?.DESCRIPTION || e?.TYPE || e?.ELEMENT_NAME || e?.MAPNAME || "") : (e?.TYPE || e?.ELEMENT_NAME || e?.MAPNAME || e?.DESCRIPTION || ""));
            }
            states.isRecord=true;
        } 
        // There will be only 1 level nesting in Field Group
        if(parent?.ICON_DISPLAY.includes("FIELD_GROUP")) states.isValid =false;
        if(prevDataType !== "DATABASE" && datatype === "DATABASE"){
            e["QUERY"] = {
                "QUERY_TYPE": "SELECT"
            }
        }

        if(prevDataType === "DATABASE" && datatype !== "DATABASE"){
            delete e["QUERY"];
        }
        
    }
    else if (FIELD_TYPE?.[e?.ICON_DISPLAY]){
        // Repeatable Field Should be same for supported data types
        if((["DELIM_FLD_ID","MULIT_DELIMITED","HL7"].includes(datatype) || 
            (datatype === "EDI" && !['4010','4010A1'].includes(version)) ) 
            && e?.REPEATING
        ){
            e['ICON_DISPLAY'] = FIELD_TYPE.FIELD_LOOP.icon;    
        }else{
            e['ICON_DISPLAY'] = DATA_TYPE?.[datatype].field.icon;
        }
        if(prevDataType ==="XML") {
            e['title'] = `${t("LBL_FIELD")} ${e.MAPNAME || e.ELEMENT_NAME || e.TYPE}`;
            e["MAPNAME"] = e.ATTRIBUTE_NAME || e.MAPNAME;
            e["DESCRIPTION"] = (e?.DESCRIPTION || e.ATTRIBUTE_NAME || e.MAPNAME)
        }
    }
    else if (e?.ICON_DISPLAY?.includes("FIELD_GROUP") && !["DELIM_FLD_ID","MULIT_DELIMITED","EDI","HL7"].includes(datatype)){
        e['ICON_DISPLAY'] = e?.LOOP_SOURCE_NAME ? RECORD_TYPE.RECORD_LOOP.icon : DATA_TYPE?.[datatype].record.icon;;
        e['title'] = `${(screen === "outbound" ? t("LBL_RECORD") : "")} ` + (screen === "outbound" ? (e?.DESCRIPTION || e?.TYPE || e?.ELEMENT_NAME || e?.MAPNAME || "") : (e?.TYPE || e?.ELEMENT_NAME || e?.MAPNAME || e?.DESCRIPTION || ""));
        states.isRecord = true;
    }
    else if (e?.ICON_DISPLAY?.includes("FIELD_GROUP") && ["DELIM_FLD_ID","MULIT_DELIMITED","EDI","HL7"].includes(datatype)){
        if((datatype === "EDI" && ["5010","5010H2"].includes(version) && e?.REPEATING) ||
            (datatype !=="EDI" && e?.REPEATING) )
        {
                e['ICON_DISPLAY'] = "REPEATING_FIELD_GROUP";
        }
        else e['ICON_DISPLAY'] = "FIELD_GROUP";
        if(parent?.ICON_DISPLAY.includes("FIELD_GROUP") && datatype === "EDI") states.isValid =false;
    }
    if (datatype !== "JSON" && e?.hasOwnProperty("GUI_XML_SORT_ORDER")) delete e?.['GUI_XML_SORT_ORDER']; 
    if (prevDataType === "XML") {
        ["ATTRIBUTE_NAME", "ELEMENT_NAME","XML_ATTRIBUTE"].forEach( key => {
            if (e?.hasOwnProperty(key)) delete e?.[key];
        })
    }
    if (datatype === "JSON" && e['GUI_XML_SORT_ORDER']) e['GUI_XML_SORT_ORDER'] = index + 1;
    return states;
}

const XMLHandler = (e,datatype,prevDataType, parent, index, screen)=>{
    let states = {isRecord:false,isValid:true};
    const isOutboundRoot = e?.key?.split('-')?.length === 2 && screen === "outbound";
    if(isOutboundRoot){
        e["EMPTY_ACTION"] = "EMPTY";
        e["FIELD"] = {
            "FIELDTYPE": "CONSTANT",
            "LENGTH": "0"
        }
        e["xmlroot"] = true;
    }

    if(e.ATTRIBUTE_NAME){
        e['ICON_DISPLAY'] = FIELD_TYPE.ATTRIBUTE.icon;
        e['MAPNAME'] = e.MAPNAME || e.ATTRIBUTE_NAME || e.TYPE;
        e['ATTRIBUTE_NAME'] = e.MAPNAME || e.ATTRIBUTE_NAME || e.TYPE;
        e['title'] = e.MAPNAME || e.ELEMENT_NAME || e.TYPE;
    }
    else if (((screen === "outbound" && e?.TYPE !== "QUERY") || screen === "inbound") && (RECORD_TYPE[e.ICON_DISPLAY] || FIELD_TYPE[e.ICON_DISPLAY] || e.ICON_DISPLAY.includes('FIELD_GROUP'))){
        if(RECORD_TYPE[e.ICON_DISPLAY] || e.TYPE) {
            // For outbound, prefer DESCRIPTION and ELEMENT_NAME over TYPE to avoid setting root element name to TYPE
            const elementName = screen === "outbound" 
                ? (e.DESCRIPTION || e.ELEMENT_NAME || e.MAPNAME || "UNNAMED_ELEMENT") 
                : (e.MAPNAME || e.ELEMENT_NAME || e.DESCRIPTION || e.TYPE || "UNNAMED_ELEMENT");
            e['title'] = `<${elementName}>`;
            e["isRecord"] = true;
            states.isRecord = true;
        }
        else {
            const elementName = e.ELEMENT_NAME || e.MAPNAME || e.DESCRIPTION || "UNNAMED_ELEMENT";
            e['title'] = `<${elementName}>`;
        }
        if(RECORD_TYPE[e.ICON_DISPLAY] && e.REPEATING) e['ICON_DISPLAY'] = RECORD_TYPE.REPEATING_ELEMENT.icon;
        else e['ICON_DISPLAY'] = RECORD_TYPE.ELEMENT.icon;
        e['MAPNAME'] = e.DESCRIPTION || e.MAPNAME || e.ELEMENT_NAME;
        if(!isOutboundRoot) e['ELEMENT_NAME'] = e.DESCRIPTION || e.ELEMENT_NAME || e.MAPNAME || "UNNAMED_ELEMENT";        
        if(e?.children?.length || (RECORD_TYPE[e.ICON_DISPLAY] && e.REPEATING)) states.isRecord = true;
        if(e?.hasOwnProperty("REPEATING")) delete e.REPEATING
    }
    if (e['GUI_XML_SORT_ORDER']) e['GUI_XML_SORT_ORDER'] = index + 1;
    return states;
};


const reGenerateInboundTemplateHeader = (datatype,prevDataType,version,data) => {
  const validKeys = [...COMMON_TEMPLATE_HEADER_PROPERTIES, ...SPECIFIC_TEMPLATE_HEADER_PROPERTIES[datatype]]; 
  const tempData = cloneDeep(data);
  Object.keys(tempData)?.forEach( e => {
    if(!validKeys.includes(e)) delete tempData?.[e];
  })
  tempData['FILETYPE'] = datatype;
  if (datatype === "DATABASE") {
    tempData["TRIMDATA"] = "FALSE";
    tempData["UNCSV"] = "FALSE";
    tempData["URLDECODE"] = "FALSE";
  }
  return tempData;  
}

const reGenerateOutboundTemplateHeader = (datatype,prevDataType,version,data) => {
    const clonedData = cloneDeep(data);
    Object.keys(clonedData)?.forEach( e => {
        if (OUTBOUND_DATATYPE_REMOVE_VALUES?.[datatype]?.includes(e)) delete clonedData?.[e];
    })
    const tempData = {
        ...clonedData,
        "FILETYPE" : datatype
    }
    
    // When changing to XML, set XML_BODY_NAME to UNNAMED_ELEMENT if not already set
    if (datatype === "XML" && prevDataType !== "XML") {
        if (!tempData.XML_BODY_NAME) {
            tempData.XML_BODY_NAME = "UNNAMED_ELEMENT";
        }
    } else if(datatype === 'GraphQL'){
          tempData.ALLOW_DYNAMIC_FILENAME =  "FALSE"
          tempData.SEND_EACH_RELATION = "TRUE";
    }
    
    return tempData;  
  }